import { render, staticRenderFns } from "./FormNovoValorProduto.vue?vue&type=template&id=44b02112&"
import script from "./FormNovoValorProduto.vue?vue&type=script&lang=js&"
export * from "./FormNovoValorProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports